export default {
    success: 'The vehicle was submitted to Torque successfully',
    warning: {
        activixPutFailed: "There was an error on Torque's side, please contact the support team",
        blocked: 'User is inactive or blocked',
        dealerNotFound: 'Dealer not found',
        invalidRequestPayload: 'Invalid request payload',
        invalidRequest: 'Invalid request, missing vehicle or user information',
        notFound: 'User not found',
        noToken: 'Dealer is not authorized to export a lead',
    },
    tooltip: {
        match: 'The submission of the vehicle through Torque is based on the make, model, year and odometer. Make sure entered values are valid before submitting',
        niv: 'You must provide a valid VIN in order to have a valid submission through Torque',
        unsubmitted: 'Submit the vehicle information through Torque',
        missingAdvisor: 'An advisor is required to submit the vehicle through Torque',
        inactiveAdvisor: 'Advisor must be active to submit the vehicle through Torque',
    },
};
